<template>
  <div class="app-tabs flex is-centered">
    <!-- <app-tab-button to="/" icon="list3" class="flex-item" :selected="tabSelected === 'hints'" /> -->
    <app-tab-button to="/" icon="bubbles" class="flex-item" :selected="tabSelected === 'conversations'" />
    <app-tab-button to="/contacts" icon="users2" class="flex-item" :selected="tabSelected === 'contacts'" />
    <!-- <app-tab-button to="/" icon="trophy" class="flex-item" :selected="tabSelected === 'goals'" /> -->
  </div>
</template>

<script>
import AppTabButton from '@/components/mobile/AppTabButton.vue'

export default {
  name: 'AppTabs',

  components: {
    AppTabButton
  },

  computed: {
    tabSelected () {
      return this.$route.meta.view
    }
  },

  TAB_HEIGHT: 50
}
</script>

<style lang="sass" scoped>
@import "@/styles/variables.sass"

.app-tabs
  width: 100%
  height: 50px
  position: relative
  min-height: 50px
  background: $gabbi-white
  &::before
    top: 0
    left: 0
    right: 0
    height: $shadow-blur
    z-index: 1
    content: ''
    position: absolute
    transform: translateY(-100%)
    background: linear-gradient(rgba($shadow-grey, 0), $shadow-grey)
    pointer-events: none

.flex-item
  margin: auto
</style>
